import React from 'react'
import { useEffect, useState } from 'react'
import { useDeleteUserMutation, useUpdateUserMutation } from './usersApiSlice'
import { Navigate, useNavigate } from 'react-router-dom'
import { ROLES } from '../../config/roles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSave, faTrashCan } from '@fortawesome/free-solid-svg-icons'
//??When getting back after an edit update the new information is not shown in the browser, only when the browser is refresshed is shown WHY?
const USER_REGEX = /^[A-z]{3,20}$/
const PWD_REGEX = /^[A-z0-9!@#$%]{4,12}$/

const EditUserForm = ({user}) => {
    const [updateUser, {
        isLoading,
        isError,
        error,
        isSuccess,
    }] = useUpdateUserMutation()

    const [deleteUser,{
        isSuccess: isDelSuccess,
        isError: isDelError,
        error: delerror
    }] = useDeleteUserMutation()

    const navigate = useNavigate()

    const [username, setUserName] = useState(user.username)
    const [validUsername, setValidUserName] = useState(false)
    const [password, setPassword] = useState('')
    const [validPassword , setValidPassword] = useState(false)
    const [ roles, setRoles] = useState(user.roles)
    const [active, setActive] = useState(user.active)

    useEffect(()=>{
        setValidUserName(USER_REGEX.test(username))
    },[username])

    useEffect(()=>{
        setValidPassword(PWD_REGEX.test(password))
    },[password])

    useEffect(()=>{
        if(isSuccess || isDelSuccess){
            setUserName('')
            setPassword('')
            setRoles([])
            navigate('/dash/users')
        }
    },[isSuccess, isDelSuccess, navigate])

    const onUsernameChanged = e => setUserName(e.target.value)
    const oncPasswordChanged = e => setPassword(e.target.value)
    const onRolesChanged = e => {
        const values = Array.from(e.target.selectedOptions,
            (option)=> option.value
        )
        setRoles(values)
    }
    const onActiveChanged = () => setActive(prev => !prev)
    const onSaveUserClicked = async (e) => {
        if(password){
            await updateUser({id:user.id, username, password, roles, active})

        }else {
            await updateUser({id:user.id, username, roles, active})
        }

    }
    const onDeleteUserClicked = async (e) =>{
        await deleteUser ({id: user.id})
    }
    const options = Object.values(ROLES).map(role=>{
        return (
            <option key={role} value={role}>{role}</option>
        )
    })
    let canSave
    if(password){
        canSave = [roles.length, validUsername, validPassword].every(Boolean) && !isLoading

    }else{
        canSave = [roles.length, validUsername].every(Boolean) && !isLoading
    }
    const errClass = (isError || isDelError) ? "errmsg" : "offscreen"
    const validUserClass = !validUsername ? 'form__input--incomplete' : ''
    const validPwdClass = password && !validPassword ? 'form__input--incomplete' : ''
    const validRolesClass = !Boolean(roles.length) ? 'form__input--incomplete' : ''

    const errContent = (error?.data?.message || delerror?.data?.message) ?? ''

    const content = (
        <>
            <p className={errClass}>{errContent}</p>
            <form className='form' onSubmit={e => e.preventDefault()}>
                <div className='form__title-row'>
                    <h2>Edit User</h2>
                    <div className='form__action-buttons'>
                        <button 
                        className='icon-button'
                        title='Save'
                        disabled={!canSave}
                        onClick={onSaveUserClicked}>
                            <FontAwesomeIcon icon={faSave}/>
                        </button>
                        <button 
                        className='icon-button'
                        title='Delete'
                        onClick={onDeleteUserClicked}
                        >
                        <FontAwesomeIcon icon={faTrashCan}/>
                        </button>
                    </div>
                </div>
                <label className= "form__label" htmlFor='username'
                >Username: <span className='nowrap'>[3-20 letters]</span> </label>
                <input 
                    className={`form__input ${validUserClass}`} 
                    id='username'
                    name='username'
                    type='text'
                    autoComplete='off'
                    value={username}
                    onChange={onUsernameChanged}/>
                <label className='form__label' htmlFor='password'>Password: <span className='nowrap'>[Empty = no change]</span><span className='nowrap'>[4-12 chars incl. !@#$%]</span></label>
                <input className={`form__input ${validPwdClass}`}
                    id='password'
                    name='password'
                    type='password'
                    value={password}
                    onChange={oncPasswordChanged}/>
                <label className='form__label form__checkbox-container' htmlFor='user-active'>ACTIVE:
                <input className='form__checkbox'
                    id='user-active'
                    name='user-active'
                    type='checkbox'
                    checked={active} 
                    onChange={onActiveChanged}/>
                </label>
                <label className='form__label' htmlFor='roles' >ASSIGNED ROLES:</label>
                <select id='roles'
                    name='roles'
                    value={roles}
                    className={`form__select ${validRolesClass}`}
                    multiple= {true}
                    size={3}
                    onChange={onRolesChanged}>
                   {options}
                </select>
                <label>Roles</label>
            </form>
        </>
    )



  return content
}

export default EditUserForm